var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin7Abb6Faf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    background: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#1976D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42 5.583H3.333V12H5.42V5.583zM11.106 5.659c-.022-.007-.043-.015-.067-.021a1.358 1.358 0 00-.084-.017 1.87 1.87 0 00-.375-.038c-1.217 0-1.989.885-2.243 1.227V5.583H6.25V12h2.087V8.5s1.578-2.197 2.243-.583V12h2.087V7.67c0-.97-.665-1.777-1.561-2.011zM4.354 4.708a1.02 1.02 0 100-2.041 1.02 1.02 0 000 2.041z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin7Abb6Faf);
export default __webpack_public_path__ + "static/media/linkedin.7abb6faf.cf518b3358a49bc2d589101133c63693.svg";
export { ForwardRef as ReactComponent };